// replay home platform video after custom interval
$( ( $ ) => {
  let video = $( '.bs-section--home-platform video' );
  video.on( 'ended', () => {
    let currentTarget = video[0];
    currentTarget.currentTime = 6;
    currentTarget.play();
  } );
} );